export const heroImage = {
  src: 'https://cdn.magicpatterns.com/uploads/5Cw1CFfMYyA3aLJMSTzPdR/hf_20260928_201544_52b974d3-4ad5-4199-beee-984954fd1d59.png',
  alt: 'The six Session Ready SLP volumes — Start the Stack, Describe & Sort, Ask & Follow, Tell It in Order, Think It Through and Take It Outside the Room — lined up on a therapy-room table',
  width: 1024,
  height: 688,
}
